export const FETCH_CATEGORIES = "CATEGORIES/FETCH_CATEGORIES";
